import { filter, includes, keyBy, map, uniq } from 'es-toolkit/compat';

import { ReportSection } from 'interfaces/agentSession';

export const sortReportSections = (sections: ReportSection[]) =>
  [...sections].sort((a, b) => a.orderIndex - b.orderIndex);

export const normalizeReportSectionOrder = (sections: ReportSection[]) =>
  map(sections, (section, orderIndex) => ({ ...section, orderIndex }));

export const removeReportSectionWithTightOrder = (sections: ReportSection[], sectionId: string) =>
  normalizeReportSectionOrder(filter(sortReportSections(sections), ({ id }) => id !== sectionId));

export const reorderReportSectionsWithTightOrder = (sections: ReportSection[], orderedSectionIds: string[]) => {
  const sortedSections = sortReportSections(sections);
  const sectionsById = keyBy(sortedSections, 'id');
  const normalizedOrderedIds = filter(uniq(orderedSectionIds), (sectionId) => Boolean(sectionsById[sectionId]));
  const reorderedSections = map(normalizedOrderedIds, (sectionId) => sectionsById[sectionId]);
  const remainingSections = filter(sortedSections, ({ id }) => !includes(normalizedOrderedIds, id));

  return normalizeReportSectionOrder([...reorderedSections, ...remainingSections]);
};
